module.exports = __webpack_public_path__ + "static/img/01.2a7dfe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/afc/01.png
// module id = yPsV
// module chunks = 0